import { ApiClient } from "@/services/ApiService";

export default {
  async deleteUserAnswer(id) {
    const response = await ApiClient.delete(`useranswer/${id}`);
    return response.data;
  },
  async getUserAnswers() {
    const response = await ApiClient.get(`useranswer`);
    return response.data;
  },
  async getUserAnswer(id) {
    const response = await ApiClient.get(`useranswer/${id}`);
    return response.data;
  },
  async postUserAnswer(useranswer) {
    const response = await ApiClient.post(`useranswer`, useranswer);
    return response.data;
  },
  async getByQuestionId(id, userTestId) {
    const response = await ApiClient.get(
      `useranswer/${id}/question/${userTestId}`
    );
    return response.data;
  },
  async getByTestId(id, userTestId) {
    const response = await ApiClient.get(`useranswer/${id}/test/${userTestId}`);
    return response.data;
  },
  async getWrongByTestId(id, userTestId) {
    const response = await ApiClient.get(
      `useranswer/${id}/test-wrong/${userTestId}`
    );
    return response.data;
  },
  async getCorrectByTestId(id, userTestId) {
    const response = await ApiClient.get(
      `useranswer/${id}/test-correct/${userTestId}`
    );
    return response.data;
  },
  async updateUserAnswer(id, answerId) {
    const response = await ApiClient.post(
      `useranswer/${id}/update-user-answer/${answerId}`
    );
    return response.data;
  }
};
